export const hashString = (str) => {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return String(hash);
};

export const trimStr = (str) => {
  return str.trim().replace(/\s+/g, ' ');
};

export const normalizeString = (str) => {
  return str.toLowerCase().replace(/\s+/g, '');
};

export const tryParseJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return [];
  }
};

export const generateRowId = (content) => {
  if (typeof content === 'string') {
    return normalizeString(
      content.replace(/[^a-zA-Z0-9]/g, '').substring(0, 250)
    );
  }

  if (typeof content === 'object') {
    let text = '';

    for (const key in content) {
      if (key === 'selection') {
        continue;
      }

      text += `${key}: ${content[key]} `;
    }

    return normalizeString(text);
  }
};
